// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"8d0dae1d","787":"f5dedd2e"}[chunkId] + ".chunk.js";
};